module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-home ui-styles",
    class: _vm.theme,
    attrs: {
      "id": "urbanannex-editor"
    }
  }, [
    [(_vm.master_loading) ? _c('div', {
      staticClass: "loading_view"
    }, [_c('div', {
      staticClass: "view_spinner_container"
    }, [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)",
        "margin": "0 auto"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "4",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    })], 1), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Loading')) + "...")])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "master_view"
    }, [_c('side-nav-bar', {
      attrs: {
        "filesOpen": _vm.filesOpen,
        "fileOpen": _vm.fileOpen,
        "reportOpen": _vm.reportOpen
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "app-container"
    }, [_c('bar'), _vm._v(" "), _c('h1', [_c('span', [_vm._v(_vm._s(_vm.$t('Annex')) + " \"" + _vm._s(_vm.urbanannex.filename) + "\"")]), (_vm.urbanannex.dirty) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), (_vm.urbanannex.dirty) ? _c('message', {
      attrs: {
        "text": _vm.page_dirty_text,
        "icon_name": "info",
        "icon_color": "rgb(0, 135, 248)",
        "border_color": "rgb(0, 135, 248)",
        "text_color": "rgb(0, 135, 248)"
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "datedata"
    }, [_c('p', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.$t('Created')) + ": " + _vm._s(_vm.millis_to_time(_vm.urbanannex.date_created)))]), _vm._v(" "), _c('p', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.$t('Last_modified')) + ": " + _vm._s(_vm.millis_to_time(_vm.urbanannex.date_modified)))])]), _vm._v(" "), _c('vue-tabs', [_c('v-tab', {
      attrs: {
        "title": _vm.data_text
      }
    }, [_c('div', {
      staticClass: "tab_content"
    }, [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "section-container"
    }, [_c('div', {
      staticClass: "field-container"
    }, [(_vm.urbanannex.url) ? _c('div', [_c('img', {
      attrs: {
        "src": _vm.urbanannex.url,
        "width": "600px",
        "height": "auto"
      }
    })]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('File_name')) + " ")]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('File_name')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.urbanannex.filename))])])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Image_footer')) + " ")]), _vm._v(" "), (_vm.urbanannex.name_ca || _vm.currentLocale === 'ca') ? _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Image_footer')) + " " + _vm._s(_vm.$t('in')) + " " + _vm._s(_vm.$t('Catalan')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.urbanannex.name_ca),
        expression: "urbanannex.name_ca"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.urbanannex.name_ca)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.urbanannex.name_ca = $event.target.value
        }, _vm.set_urbanannex_name_ca]
      }
    })])]) : _vm._e(), _vm._v(" "), (_vm.urbanannex.name_en || _vm.currentLocale === 'en') ? _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Image_footer')) + " " + _vm._s(_vm.$t('in')) + " " + _vm._s(_vm.$t('English')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.urbanannex.name_en),
        expression: "urbanannex.name_en"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.urbanannex.name_en)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.urbanannex.name_en = $event.target.value
        }, _vm.set_urbanannex_name_en]
      }
    })])]) : _vm._e(), _vm._v(" "), (_vm.urbanannex.name_es || _vm.currentLocale === 'es') ? _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Image_footer')) + " " + _vm._s(_vm.$t('in')) + " " + _vm._s(_vm.$t('Spanish')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.urbanannex.name_es),
        expression: "urbanannex.name_es"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.urbanannex.name_es)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.urbanannex.name_es = $event.target.value
        }, _vm.set_urbanannex_name_es]
      }
    })])]) : _vm._e()])])])]), _vm._v(" "), _c('v-tab', {
      attrs: {
        "title": _vm.metadata_text
      }
    }, [_c('div', {
      staticClass: "tab_content"
    }, [_c('form', {
      staticClass: "bt-form"
    })])])], 1), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoUp($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "chevron-left",
        "text": _vm.goup_button_text,
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray"
      }
    })], 1)]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onSaveCurrentUrbanAnnex({
            go_up: false
          })
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "floppy-o",
        "text": _vm.save_button_text,
        "icon_color": "white",
        "text_color": "white",
        "border_color": "#006bc5",
        "background_color": "#0087F8"
      }
    })], 1)]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onSaveCurrentUrbanAnnex({
            go_up: true
          })
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "floppy-o",
        "text": _vm.save_and_go_up_button_text,
        "icon_color": "white",
        "text_color": "white",
        "border_color": "#006bc5",
        "background_color": "#0087F8"
      }
    })], 1)]), _vm._v(" "), (_vm.urbanannex.dirty) ? _c('message', {
      attrs: {
        "text": _vm.page_dirty_text,
        "icon_name": "info",
        "icon_color": "rgb(0, 135, 248)",
        "border_color": "rgb(0, 135, 248)",
        "text_color": "rgb(0, 135, 248)"
      }
    }) : _vm._e()], 1)], 1)]
  ], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7ba17e56!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/app/urbanannexes/UrbanAnnexEditor.vue
// module id = 2168
// module chunks = 0